(() => {
  if (typeof window.FarazineSoundtrack?.prepare === 'function') { window.FarazineSoundtrack.prepare(); return; }
  const instances = new Map();
  const radio = () => typeof window.FaraRadio?.startIssue === 'function' && typeof window.FaraRadio?.getState === 'function' ? window.FaraRadio : null;
  function mount(root) {
    const toggle = root.querySelector('[data-soundtrack-toggle]');
    const next = root.querySelector('[data-soundtrack-next]');
    const status = root.querySelector('[data-soundtrack-status]');
    const label = root.querySelector('[data-soundtrack-label]');
    const icon = root.querySelector('[data-soundtrack-icon]');
    if (!toggle || !status || !label) return null;
    let handles;
    try { handles = JSON.parse(root.dataset.handles); } catch { return null; }
    if (!Array.isArray(handles) || !handles.length || handles.some(handle => typeof handle !== 'string')) return null;
    const definition = {id: root.dataset.edition, title: root.dataset.title || '', handles, completeMessage: root.dataset.completeLabel || ''};
    let disposed = false;
    function paint() {
      if (disposed || !root.isConnected) return;
      const api = radio(), state = api?.getState();
      toggle.hidden = !api;
      root.querySelectorAll('[data-soundtrack-track]').forEach(button => { button.hidden = !api; });
      const active = state?.issue?.id === definition.id;
      const playing = active && state.playing;
      const intended = active && state.intended;
      label.textContent = playing || intended ? root.dataset.pauseLabel : root.dataset.playLabel;
      if (icon) icon.textContent = playing ? 'Ⅱ' : '▶';
      toggle.setAttribute('aria-pressed', String(Boolean(playing)));
      if (next) { next.hidden = !api; next.disabled = !active; }
      root.classList.toggle('is-playing', Boolean(playing));
      root.querySelectorAll('[data-soundtrack-row]').forEach(row => {
        if (active && Number(row.dataset.soundtrackRow) === state.issue.index) row.setAttribute('aria-current', 'true');
        else row.removeAttribute('aria-current');
      });
      const message = active ? (playing ? root.dataset.playingLabel : root.dataset.pausedLabel) : state?.completedIssueId === definition.id ? root.dataset.completeLabel : root.dataset.readyLabel;
      status.textContent = (message || '').replace('__track__', state?.track ? state.track.title + ' — ' + state.track.artist : '').replace('__position__', String((state?.issue?.index || 0) + 1)).replace('__total__', String(handles.length));
    }
    function click(event) {
      const button = event.target.closest('[data-soundtrack-toggle],[data-soundtrack-next],[data-soundtrack-track]');
      if (!button || !root.contains(button) || button.disabled || disposed || !root.isConnected) return;
      const api = radio();
      if (!api) return;
      event.preventDefault();
      const state = api.getState();
      const start = index => Promise.resolve(api.startIssue(definition, index)).then(result => {
        if (result === false && !disposed && root.isConnected) status.textContent = root.dataset.errorLabel || '';
      });
      if (button.hasAttribute('data-soundtrack-next')) api.next();
      else if (button.hasAttribute('data-soundtrack-track')) start(Number(button.dataset.soundtrackTrack));
      else if (state.issue?.id === definition.id) {
        if (state.playing || state.intended) api.pause();
        else api.resume();
      } else start(0);
      paint();
    }
    root.addEventListener('click', click);
    paint();
    return {paint, dispose() { disposed = true; root.removeEventListener('click', click); instances.delete(root); }};
  }
  function prepare() {
    for (const [root, instance] of instances) if (!root.isConnected) instance.dispose();
    document.querySelectorAll('[data-farazine-soundtrack]').forEach(root => {
      if (!instances.has(root)) { const instance = mount(root); if (instance) instances.set(root, instance); }
    });
    for (const instance of instances.values()) instance.paint();
  }
  window.addEventListener('fara:radio-state', prepare);
  window.addEventListener('fara:before-navigate', () => { for (const instance of instances.values()) instance.dispose(); });
  document.addEventListener('shopify:section:load', prepare);
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, instance] of instances) if (event.target === root || event.target.contains?.(root)) instance.dispose();
  });
  window.FarazineSoundtrack = {prepare};
  prepare();
})();
